const userCurrency = window.Shopify.currency;
const currencySymbol = {
  USD: "$",
  EUR: "€",
  MXN: "$",
};

window.compareSymbol = () => {
  return currencySymbol[userCurrency.active] ?? "€";
};

window.toEuro = (price) => {
  if (window.Shopify.currency.active == "EUR") {
    return price.toFixed(2) + compareSymbol();
  } else {
    return compareSymbol() + price.toFixed(2);
  }
};

export const numberWithCommas = (x) => {
  return compareSymbol() + x.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
}

export const toDiscount = (price) => {
  return `${Math.floor(price)}`
};